import './slider';

$(function () {
  $(".toggler").on("click", function () {
    const $header = $("#header");
    $(this).add($header).toggleClass("active");
    const isExpanded = $header.hasClass("active");
    $(this).attr("aria-expanded", isExpanded ? "true" : "false");
  });

  const updateScrollbarWidth = () => {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty(
      "--scrollbar-width",
      `${scrollbarWidth}px`
    );
  };

  const updateHeaderHeight = () => {
    const header = document.getElementById("header");
    if (!header) {
      return;
    }
    const { height } = header.getBoundingClientRect();
    document.documentElement.style.setProperty(
      "--header-height",
      `${height}px`
    );
  };

  updateScrollbarWidth();
  updateHeaderHeight();
  window.addEventListener("resize", updateScrollbarWidth);
  window.addEventListener("resize", updateHeaderHeight);

  const setHeadingsMargin = () => {
    const $sections = $(".indy-block-section .offset-2");

    $sections.each(function () {
      const $section = $(this);
      const marginLeft = $section.css("margin-left");
      const $columns = $section.find(".indy-block-columns");

      $columns.each(function () {
        $(this)
          .find(".wp-block-heading")
          .first()
          .css("margin-left", `-${marginLeft}`);
      });
    });
  };

  setHeadingsMargin();
  $(window).on("resize", setHeadingsMargin);

  // Scroll offset functionality
  $("#header .nav-link, .indy-block-hero__menu-link").on(
    "click",
    function (event) {
      const targetId = $(this).attr("href");

      if (!targetId || !targetId.startsWith("#")) {
        return;
      }

      event.preventDefault();

      const $targetElement = $(targetId);

    // adjust this, to change the offset to the headings
    const offset = 90;

    if ($targetElement.length) {
      $("html, body").animate(
        {
          scrollTop: $targetElement.offset().top - offset
        },
        100
      );

      // close navigation after click on link element
      $(".nav-wrapper").removeClass("active");
      $("#header").removeClass("active");
      $(".toggler").attr("aria-expanded", "false");
    }
    }
  );

  const $heroBlock = $(".indy-block-hero");
  const $header = $("#header");
  const $heroNav = $(".indy-block-hero__nav");

  if ($heroBlock.length && $header.length) {
    $("body").addClass("has-hero-block");

    const updateHeaderVisibility = () => {
      const shouldShowHeader = window.scrollY >= window.innerHeight;
      $header.toggleClass("is-visible", shouldShowHeader);
	  $heroNav.toggleClass("is-invisible", shouldShowHeader);
    };

    updateHeaderVisibility();
    window.addEventListener("scroll", updateHeaderVisibility, { passive: true });
    window.addEventListener("resize", updateHeaderVisibility);
  }

  const initialWidth = window.innerWidth;
  const reloadThreshold = 100; // Anzahl Pixel, bei denen ein Reload ausgelöst werden soll
  let hasReloaded = false;

  window.addEventListener("resize", () => {
    const currentWidth = window.innerWidth;

    if (!hasReloaded && Math.abs(currentWidth - initialWidth) >= reloadThreshold) {
      hasReloaded = true;
      window.location.reload();
    }
  });
});
